import { render, staticRenderFns } from "./OverdueTaskBaseTable.vue?vue&type=template&id=6112ee0f"
import script from "./OverdueTaskBaseTable.vue?vue&type=script&lang=js"
export * from "./OverdueTaskBaseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports